// Core
import { takeEvery } from 'redux-saga/effects';

// Instruments
import { compareActions } from 'bus/compare/actions';
import { addToCompareWorker, removeFromCompareWorker, loadLocalComparedWorker } from './workers';

export const compareWatchers = Object.freeze({
    * addToCompareWatcher () {
        yield takeEvery(compareActions.addToCompare, addToCompareWorker);
    },
    * removeFromCompareWatcher () {
        yield takeEvery(compareActions.removeFromCompare, removeFromCompareWorker);
    },
    * loadLocalComparedWatcher () {
        yield takeEvery(compareActions.loadLocalCompared, loadLocalComparedWorker);
    },
});
